import { Pipe, PipeTransform } from '@angular/core';
import { Location } from '@freelancer/datastore/collections';

/**
 * Get the location of the user
 *
 * Usage: `{{ location | flLocation }}`
 */

@Pipe({ name: 'flLocation' })
export class LocationPipe implements PipeTransform {
  transform(location: Location): string {
    if (location && location.fullAddress) {
      return location.fullAddress;
    }

    if (location && location.country) {
      if (location.administrativeArea && location.city) {
        return `${location.city}, ${location.administrativeArea}, ${location.country.name}`;
      }

      if (location.city) {
        return `${location.city}, ${location.country.name}`;
      }

      if (location.administrativeArea) {
        return `${location.administrativeArea}, ${location.country.name}`;
      }
      return location.country.name;
    }

    if (location && location.city) {
      if (location.administrativeArea) {
        return `${location.city}, ${location.administrativeArea}`;
      }
      return location.city;
    }

    return '';
  }
}
